import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { transformRequest, encryptQueryString } from "../../utils/API/requestMiddleware"
// import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const followupReasonAPI = createApi({
    reducerPath: 'followupReasonAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        addEditFollowupReason: builder.mutation({
            query: (details) => ({
                url: '/FollowupReason/AddEditFollowupReason',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getFollowupReason: builder.query({
            query: () => ({
                url: encryptQueryString(`/FollowupReason/GetFollowupReason`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateFollowupReason: builder.mutation({
            query: (details) => ({
                url: '/FollowupReason/UpdateFollowupReason',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteFollowupReason: builder.mutation({
            query: (FollowupReasonId) => ({
                url: `/FollowupReason/DeleteFollowupReason?FollowupReasonId=${FollowupReasonId}`,
                method: 'DELETE',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getFollowupReasonById: builder.query({
            query: (FollowupReasonId) => ({
                url: `/FollowupReason/GetFollowupReasonById?FollowupReasonId=${FollowupReasonId}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
})
export const {
    useAddEditFollowupReasonMutation,
    useLazyGetFollowupReasonQuery,
    useUpdateFollowupReasonMutation,
    useDeleteFollowupReasonMutation,
    useLazyGetFollowupReasonByIdQuery,
} = followupReasonAPI;

export default followupReasonAPI;